import { render, staticRenderFns } from "./page-selector.vue?vue&type=template&id=7b1ceb70&scoped=true&"
import script from "./page-selector.vue?vue&type=script&lang=js&"
export * from "./page-selector.vue?vue&type=script&lang=js&"
import style0 from "./page-selector.vue?vue&type=style&index=0&id=7b1ceb70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ceb70",
  null
  
)

export default component.exports